export default "/assets/images/Suzzne-cat.032dc1c9d3984448.webp";